"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "andreis": {
    "ba51cf74": [{
      "hkey": "bb16b729",
      "slug": "andreis",
      "name": "Andreis",
      "primary": true,
      "skipSearch": false
    }],
    "rompagnel": [{
      "hkey": "bb16b729",
      "slug": "andreis",
      "name": "Andreis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;